import React from 'react'
import {SubHeroText} from './Styles'
import RepositoryTable from './RepositoryTable'
function SoftwareLanding() {
    return (
        <div class="content-wrapper">
            <div class="row h-100">
                <div class="col">
                    <div class="row">
                        <SubHeroText>
                            Software Repository
                        </SubHeroText>
                    </div>
                    <div class="row">
                        <RepositoryTable/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SoftwareLanding
